import { useMutation } from '@urql/vue'
import { useRoute } from 'vue-router'
import { watch } from 'vue'

const trackUserEventMutation = `
  mutation TrackUserEvent($eventType: String!, $path: String!, $metadata: String) {
    trackUserEvent(eventType: $eventType, path: $path, metadata: $metadata) {
      id
    }
  }
`

export function useUserTracking() {
  const route = useRoute()
  const { executeMutation: trackEvent } = useMutation(trackUserEventMutation)

  // Track route changes
  watch(
    () => route.fullPath,
    async (newPath) => {
      await trackEvent({
        eventType: 'PAGE_VIEW',
        path: newPath,
      })
    },
    { immediate: true },
  )

  // Function to track custom events
  const trackCustomEvent = async (
    eventType: string,
    metadata?: Record<string, any>,
  ) => {
    await trackEvent({
      eventType,
      path: route.fullPath,
      metadata: metadata ? JSON.stringify(metadata) : undefined,
    })
  }

  return {
    trackCustomEvent,
  }
}
